import React from "react";
import { cn } from "@/lib/utils";
import useAdminAmbient from "@/hooks/useAdminAmbient";
import AmbientOrbs from "@/components/admin/AmbientOrbs";
import CursorGlow from "@/components/admin/CursorGlow";

export default function AdminAmbientShell({ children, className, trackCursor = true, ...props }) {
  const { intensity } = useAdminAmbient();
  return (
    <div
      className={cn(
        "admin-shell admin-canvas relative flex min-h-[100dvh] min-w-0 overflow-x-hidden",
        intensity === "off" && "admin-solid",
        className,
      )}
      data-ambient={intensity}
      {...props}
    >
      <AmbientOrbs intensity={intensity} />
      {trackCursor && intensity !== "off" && <CursorGlow />}
      {children}
    </div>
  );
}
